import styled, { css } from 'styled-components/macro';
import { hexToRGB } from '@repo-level/core-front';

interface ScRegistrationBannerProps {
  isVipBenefits?: boolean;
}

export const ScRegistrationBanner = styled.div<ScRegistrationBannerProps>`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: ${({ isVipBenefits }) => (isVipBenefits ? '12px' : '16px')};
  border-radius: 16px 0 0 16px;

  .offers {
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .title {
      width: 100%;
      font-weight: 800;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
    }

    .offer {
      width: 100%;
      text-align: center;
      height: ${({ isVipBenefits }) => (isVipBenefits ? '100px' : '100%')};
      font-weight: 800;
      font-size: 24px;
      line-height: 32px;
      letter-spacing: 0.01em;
      color: ${({ theme }) => theme.whiteColor};

      ${({ isVipBenefits }) =>
        isVipBenefits &&
        css`
          display: flex;
          flex-direction: column;
          text-align: center;
          align-items: center;
          justify-content: center;
        `}
    }
  }
`;

export const ScLink = styled.a`
  color: ${({ theme }) => theme.greenColor};
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      opacity: 0.6;
    }
  }
`;

export const ScCheckboxesList = styled.div<{ isOpenPromoCheckboxes: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .promo-checkboxes {
    display: ${({ isOpenPromoCheckboxes }) =>
      isOpenPromoCheckboxes ? 'flex' : 'none'};
    flex-direction: column;
    margin-left: 32px;
    gap: 12px;
  }
`;

export const ScFieldGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 120px;
  gap: 8px;
`;
